import { Observable } from 'rxjs';
import { AccountTypeModel } from '@src/core/domain/account/accountType.model';

export abstract class AccountTypeRepository {
  abstract getAllaccountTypes(): Observable<AccountTypeModel>;
  abstract getAllAccountsByFuncionality(functionality: string, filter: boolean);
}
